import { ItemProps } from '@@/form-components/InputList';
import { InputGroup } from '@@/form-components/InputGroup';

export function SELinuxOptionItem({
  item,
  onChange,
  index,
}: ItemProps<{
  level: string;
  role: string;
  type: string;
  user: string;
}>) {
  return (
    <div className="flex gap-2">
      <InputGroup size="small" className="w-24">
        <InputGroup.Addon>Level</InputGroup.Addon>
        <InputGroup.Input
          type="text"
          className="form-control"
          value={item.level}
          onChange={(e) => onChange({ ...item, level: e.target.value })}
          data-cy={`selinux-option-${index}-level`}
        />
      </InputGroup>
      <InputGroup size="small" className="w-24">
        <InputGroup.Addon>Role</InputGroup.Addon>
        <InputGroup.Input
          type="text"
          className="form-control"
          value={item.role}
          onChange={(e) => onChange({ ...item, role: e.target.value })}
          data-cy={`selinux-option-${index}-role`}
        />
      </InputGroup>
      <InputGroup size="small" className="w-24">
        <InputGroup.Addon>Type</InputGroup.Addon>
        <InputGroup.Input
          type="text"
          className="form-control"
          value={item.type}
          onChange={(e) => onChange({ ...item, type: e.target.value })}
          data-cy={`selinux-option-${index}-type`}
        />
      </InputGroup>
      <InputGroup size="small" className="w-24">
        <InputGroup.Addon>User</InputGroup.Addon>
        <InputGroup.Input
          type="text"
          className="form-control"
          value={item.user}
          onChange={(e) => onChange({ ...item, user: e.target.value })}
          data-cy={`selinux-option-${index}-user`}
        />
      </InputGroup>
    </div>
  );
}
